import React, { Component } from 'react'
import { Select, SelectItem } from '@wfp/ui'
import { setNarrative } from '../actions/narrative'
import { connect } from 'react-redux'

export class Disclaimer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disclaimerDisabled: !this.props.narrative.disclaimer_id,
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.narrative.disclaimer_id !== this.props.narrative.disclaimer_id) {
      this.setState({ disclaimerDisabled: !(nextProps.narrative && nextProps.narrative.disclaimer_id) })
    }
  }

  onChange = event => {
    let newDisclaimerId
    let newDisclaimerDisabled
    if (event.target.type === 'checkbox') {
      newDisclaimerId = event.target.checked ? this.props.narrative.disclaimer_id : null
      newDisclaimerDisabled = !event.target.checked
    } else if (event.target.type === 'select-one') {
      newDisclaimerId = parseInt(event.target.value, 10)
      newDisclaimerDisabled = this.state.disclaimerDisabled
    }
    this.setState({ disclaimerDisabled: newDisclaimerDisabled })
    const { setNarrative, narrative } = this.props
    setNarrative({
      ...narrative,
      disclaimer_id: newDisclaimerDisabled ? null : newDisclaimerId,
    })
  }

  render() {
    const userCanDisclaimer = this.props.narrative.user_can_disclaimer || this.props.narrative.user_can_save
    return (
      <div className='Disclaimer'>
        <span>
          Show Disclaimer:&nbsp;
          <input
            type='checkbox'
            checked={!this.state.disclaimerDisabled}
            onChange={this.onChange}
            name='chkDisclaimer'
            disabled={!userCanDisclaimer}
          />
        </span>
        &nbsp;
        <Select
          hideLabel
          id='cboDisclaimer'
          onChange={this.onChange}
          value={
            !this.state.disclaimerDisabled && this.props.narrative.disclaimer_id
              ? this.props.narrative.disclaimer_id
              : ''
          }
          disabled={this.state.disclaimerDisabled || !userCanDisclaimer}>
          <SelectItem value='' text='Choose disclaimer' disabled hidden />

          {this.props.disclaimers &&
            this.props.disclaimers.map(disclaimer => (
              <SelectItem value={disclaimer.id} text={disclaimer.sentence} key={disclaimer.id} />
            ))}
        </Select>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return { narrative: state.narrative.narrative, disclaimers: state.disclaimers }
}

const mapDispatchToProps = { setNarrative }

Disclaimer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Disclaimer)

export default Disclaimer
